import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = { pos: "#10B981", neg: "#EF4444", neu: "#6B7280" };

export function ChartDonut({ pos, neg, neu }: { pos: number; neg: number; neu: number }) {
  const data = [
    { name: "Positivo", value: pos, key: "pos" as const },
    { name: "Negativo", value: neg, key: "neg" as const },
    { name: "Neutral", value: neu, key: "neu" as const },
  ];
  return (
    <ResponsiveContainer width="100%" height={100}>
      <PieChart>
        <Pie data={data} dataKey="value" innerRadius={28} outerRadius={45} paddingAngle={2}>
          {data.map((d) => (
            <Cell key={d.key} fill={COLORS[d.key]} />
          ))}
        </Pie>
        <Tooltip formatter={(v: number) => v.toLocaleString("es-PE")} />
      </PieChart>
    </ResponsiveContainer>
  );
}
